<template>
    <svg :cssClass="cssClass" :class="iconCssClass" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 0C3.58888 0 0 3.58888 0 8C0 12.4111 3.58888 16 8 16C12.4111 16 16 12.4111 16 8C16 3.58888 12.4111 0 8 0ZM8 15C4.14013 15 1 11.8599 1 8C1 4.14013 4.14013 1 8 1C11.8599 1 15 4.14013 15 8C15 11.8599 11.8599 15 8 15Z" fill="#18437E"/>
        <path d="M8.5 3H7.5V8.20702L10.6465 11.3535L11.3535 10.6465L8.5 7.79295V3Z" fill="#18437E"/>
    </svg>

</template>

<script>
    export default {

        props: {
            cssClass: {
                type: String,
                default: () => '',
            },
        },

        computed: {

            iconCssClass()
            {
                return `icon-svg ${this.cssClass} icon-svg--priest`
            },

        },

    }
</script>

<style lang="scss">
    .icon-svg {
        &.icon-svg--priest {
            width: 30px;
            height: 30px;
        }
    }
</style>
